import { render, staticRenderFns } from "./interviewStatus.vue?vue&type=template&id=1218a5e0&scoped=true&"
import script from "./interviewStatus.vue?vue&type=script&lang=js&"
export * from "./interviewStatus.vue?vue&type=script&lang=js&"
import style0 from "./interviewStatus.vue?vue&type=style&index=0&id=1218a5e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1218a5e0",
  null
  
)

export default component.exports